import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Table } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import Loading from "../../components/Common/Loading";

function JobApplications(props) {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get GET_APPLICATIONS
  const getApplications = () => {
    setIsLoading(true);
    apiReq(url.GET_APPLICATIONS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setList(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getApplications();
  }, []);

  // handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_APPLICATIONS + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire("Deleted!", res.message, "success");
              getApplications();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text, record, index) => <span>{record.email}</span>,
    },
    {
      title: "mobile",
      render: (text, record, index) => <span>{record.mobile}</span>,
    },
    {
      title: "Notice Period",
      render: (text, record, index) => <span>{record.notice} Days</span>,
    },
    {
      title: "Applied for",
      render: (text, record, index) => <span>{record.post}</span>,
    },
    {
      title: "Resume",
      render: (text, record, index) => (
        <span>
          {record.resume ? (
            <a
              href={record.resume}
              target="_blank"
              className="btn btn-primary btn-sm"
            >
              Download
            </a>
          ) : (
            "NA"
          )}
        </span>
      ),
    },
    {
      title: "Applied Date",
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(record._id)}
        >
          <i className="ri-delete-bin-line"></i>
        </button>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Jobs</h5>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={list}
                  bordered
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default JobApplications;
